import WhatsAppTemplatesService from '@/services/WhatsAppTemplatesService';

class WhatsAppCloudApiService {
  static getPhoneNumbers() {
    const companyId = WhatsAppTemplatesService.getCompanyId();
    return WhatsAppTemplatesService.request(
      `/whatsapp/cloudapi/phone-numbers?company_id=${companyId}`
    );
  }

  // Estado de la conexión con Cloud API para la company: si hay un WhatsApp
  // Business (WABA) conectado y los números de la cuenta con su estado de
  // registración en nuestros servicios.
  // Contrato:
  //   { connected: boolean, waba_id: string|null, phone_numbers: [
  //       { phone_number, display_phone_number,
  //         business_portfolio,            // "Company business portfolio"
  //         whatsapp_business_account,     // nombre/id de la WABA
  //         registration_status: 'REGISTERED'|'PENDING'|'NOT_REGISTERED' } ] }
  static getConnectionStatus() {
    const companyId = WhatsAppTemplatesService.getCompanyId();
    return WhatsAppTemplatesService.request(
      `/whatsapp/cloudapi/status?company_id=${companyId}`
    );
  }

  // Desconecta (unlink) la cuenta de WhatsApp Business (WABA) de la company.
  static disconnectAccount() {
    const companyId = WhatsAppTemplatesService.getCompanyId();
    return WhatsAppTemplatesService.request('/whatsapp/cloudapi/disconnect', {
      method: 'POST',
      body: JSON.stringify({ company_id: companyId }),
    });
  }

  static getMessageDeliveryError(getstreamId) {
    const companyId = WhatsAppTemplatesService.getCompanyId();
    return WhatsAppTemplatesService.request(
      `/whatsapp/cloudapi/messages/${encodeURIComponent(
        getstreamId
      )}/delivery-error?company_id=${companyId}`
    );
  }
}

export default WhatsAppCloudApiService;
